import { useIsMutating } from '@tanstack/react-query';

import { UPLOAD_ORDER_MUTATION_KEY } from '@widgets/OrdersRecognition/model/queryKeys';

export const useIsUploadingStatus = () => {
    const uploadingCount = useIsMutating({ mutationKey: UPLOAD_ORDER_MUTATION_KEY });
    const isUploading = uploadingCount > 0;

    return isUploading;
}
